import { render } from "./RoadMapCategory.vue?vue&type=template&id=4a5cda96"
import script from "./RoadMapCategory.vue?vue&type=script&lang=ts"
export * from "./RoadMapCategory.vue?vue&type=script&lang=ts"
script.render = render

export default script